import { isShopifyEmbedded } from "@shopify/app-bridge-utils"
import React from "react"

import { useEditorShortcuts } from "@/hooks/useEditorShortcuts"

import AdminSaveModule from "./AdminSaveModule"
import ShopifySaveModule from "./ShopifySaveModule"

interface SaveModuleProps {
  onSave: () => void
  onDiscard: () => void
  show: boolean
  unlocking?: boolean
  loading?: boolean
  disabled?: boolean
  subRouteBlock?: boolean
  title?: string
  message?: string
  secondaryLabel?: string
  allowedPaths?: string[]
  isTrackingPage?: boolean
}

const SaveModule: React.FC<SaveModuleProps> = (props) => {
  const { show, loading, disabled, unlocking, onSave } = props

  // 全局 Cmd/Ctrl + S 保存：仅在保存条可操作时触发
  useEditorShortcuts({
    onSave: () => {
      if (show && !loading && !disabled && !unlocking) {
        onSave()
      }
    },
  })

  const isShopifyAppBridge = isShopifyEmbedded() && !window.isFromAdmin

  if (isShopifyAppBridge) {
    return <ShopifySaveModule {...props} />
  }

  return <AdminSaveModule {...props} />
}

export default SaveModule
